<template>
  <div class="wompi-resultado-container">
    <div class="loader-container" v-if="loading">
      <div class="loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p class="loader-text">Verificando tu pago...</p>
    </div>

    <div class="error-container" v-else-if="error">
      <h2>Error al procesar el pago</h2>
      <p>{{ error }}</p>
      <button @click="volverAlCheckout" class="btn btn-primary">
        Intentar nuevamente
      </button>
    </div>
  </div>
</template>

<script>
import secureApi from '@/plugins/axios-secure';

export default {
  name: 'WompiResultado',
  data() {
    return {
      loading: true,
      error: null,
      maxRetries: 10, 
      retryCount: 0,
      retryInterval: null
    };
  },

  methods: {
    async verificarTransaccion(idTransaccion) {
      try {
        const resp = await secureApi.get('/payments/wompi/result', {
          params: { idTransaccion }
        });
        return resp.data;
      } catch (e) {
        console.error('Error verificando transacción:', e);
        return null;
      }
    },

    async esperarConfirmacion(idTransaccion) {
      const delays = [1000, 2000, 3000, 5000, 8000, 13000, 21000, 34000, 55000, 89000];
      
      for (let i = 0; i < delays.length; i++) {
        if (i > 0) {
          await new Promise(r => setTimeout(r, delays[i]));
        }
        
        const data = await this.verificarTransaccion(idTransaccion);
        
        if (data?.uniqd) {
          this.redirigirAOrdenCompleta(data.uniqd);
          return;
        }
        
        this.retryCount = i + 1;
      }
      
      throw new Error('No se pudo confirmar el pago. Por favor, verifica el estado de tu orden en tu perfil.');
    },

    async redirigirAOrdenCompleta(uniqd) {
      this.loading = false;

     localStorage.removeItem('carts')

      this.$notify({
        title: "¡Pago exitoso!",
        text: "Estamos procesando tu compra.",
        duration: 3000,
        type: 'success'
      });

      this.$router.replace({
        name: 'OrderSuccess',
        params: { uniqd: encodeURIComponent(uniqd) }
      });
    },

    volverAlCheckout() {
      this.$router.replace({ name: 'NewCheckout' });
    }
  },

  async mounted() {
    const idTransaccion = this.$route.query.idTransaccion;
    
 
    if (!idTransaccion) {
      this.$notify({
        title: "Acceso no permitido",
        text: "No se puede acceder a esta página sin una transacción válida.",
        duration: 3000,
        type: 'warning'
      });
      
      setTimeout(() => {
        this.$router.replace('/');
      }, 500);
      
      return;
    }

    try {
      const data = await this.verificarTransaccion(idTransaccion);
      
      if (data?.uniqd) {
        this.redirigirAOrdenCompleta(data.uniqd);
      } else {
        await this.esperarConfirmacion(idTransaccion);
      }
    } catch (e) {
      this.loading = false;
      this.error = e.message || 'Ocurrió un error al verificar el pago.';
      
      this.$notify({
        title: "Error",
        text: this.error,
        duration: 5000,
        type: 'error'
      });
    }
  },

  beforeUnmount() {
    if (this.retryInterval) {
      clearInterval(this.retryInterval);
    }
  }
};
</script>

<style scoped>
.wompi-resultado-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
}

.loader-container {
  text-align: center;
  background: white;
  padding: 60px 40px;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.loader {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 30px;
}

.loader span {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #4184f3;
  animation: bounce 1.4s infinite ease-in-out both;
}

.loader span:nth-child(1) {
  animation-delay: -0.32s;
}

.loader span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.loader-text {
  font-size: 18px;
  color: #333;
  font-weight: 500;
}

.error-container {
  text-align: center;
  background: white;
  padding: 60px 40px;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
}

.error-container h2 {
  color: #e74c3c;
  margin-bottom: 15px;
}

.error-container p {
  color: #555;
  margin-bottom: 30px;
  line-height: 1.6;
}

.btn {
  padding: 15px 40px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: #4184f3;
  color: white;
}

.btn-primary:hover {
  background: #3367d6;
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(65, 132, 243, 0.3);
}
</style>